(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ll-sofa-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ll-sofa-size-guide')) {
    customElements.define('ll-sofa-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        this.select = this.querySelector('[data-size-guide-select]');
        this.configurations = [...this.querySelectorAll('[data-size-guide-configuration]')];
        this.returnFocus = null;

        this.select?.addEventListener('change', (event) => {
          this.showConfiguration(event.currentTarget.value);
        });

        this.querySelector('[data-size-guide-open]')?.addEventListener('click', (event) => {
          this.returnFocus = event.currentTarget;
          this.dialog?.showModal();
          this.querySelector('[data-size-guide-close]')?.focus();
        });

        this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.closeDialog());

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDialog();
        });
        this.dialog?.addEventListener('close', () => this.returnFocus?.focus());
        this.showConfiguration(this.select?.value || '0');
      }

      closeDialog() {
        this.dialog?.close();
      }

      showConfiguration(index) {
        this.configurations.forEach((configuration) => {
          configuration.hidden = configuration.dataset.sizeGuideConfiguration !== String(index);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
